import { SendFileModal } from './SendFileModal.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(SendFileModal)
export { withUnmountHoc as SendFileModal }
